import React from 'react';
import { ReactNode } from 'react';

interface TableBodyProps {
  children: ReactNode;
  className?: string;
}

const TableBody = ({ children, className }: TableBodyProps) => {
  return <div className={className}>{children}</div>;
};

export default TableBody;
